module.exports = __webpack_public_path__ + "img/popup_icon.00d2cb02.png";